import * as pako from "pako"
import { Dictionary } from "@/core/collections/dictionary"
import { JsonUtil } from "@/core/api/utils/json_util"
import { ResponseModel } from "@/core/api/models/response_model"
import { ProtoResponseModel } from "@/core/api/proto/models/protoResponseModel"
import { getClassType } from "@/core/api/decorators/serializable_decorator"
import { ClassUtil } from "./utils/class_util"

export class ResponseSerializer {
  public static serialize<T>(model: T, useCompression: boolean): string {
    const classes: string[] = ClassUtil.getClassNames(model)
    const encData: string = JsonUtil.serializeJson64(model)
    const dataBinary: Uint8Array = new ProtoResponseModel({
      data: encData,
      classes: classes,
    }).serializeBinary()
    if (useCompression) {
      let dataCompressed: Uint8Array
      dataCompressed = pako.gzip(dataBinary)

      const data: string = JSON.stringify(Array.from(dataCompressed))
      return data
    }

    const data: string = JSON.stringify(Array.from(dataBinary))

    return data
  }

  public static deserialize<T>(
    response: ResponseModel,
    classes: Dictionary<any> | null = null,
  ): T | null {
    if (!response.data) {
      return null
    }

    const arr: number[] = JSON.parse(response.data as string) as number[]
    const bytes: Uint8Array = new Uint8Array(arr)

    const data: Uint8Array = response.iscompressed ? pako.ungzip(bytes) : bytes

    const model: T | null = ResponseSerializer._deserialize_binary<T>(
      data,
      classes,
    )

    return model
  }

  private static _deserialize_binary<T>(
    data: Uint8Array,
    classes: Dictionary<any> | null = null,
  ): T | null {
    const response: ProtoResponseModel =
      ProtoResponseModel.deserializeBinary(data)
    if (classes === null) {
      classes = {}
      response.classes.map((name: string) => {
        if (classes) {
          classes[name] = getClassType(name)
        }
      })
    }

    const model: T | null = JsonUtil.deserializeJson64<T>(
      response.data,
      classes,
    )

    return model
  }
}
